import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { filterSportsEmitLast } from '@frontend/sports/host-app/sports-product/feature/utils';
import { UserService } from '@frontend/sports/user/feature';
import { UserLoginEvent, UserLogoutEvent } from '@frontend/vanilla/core';
import { Store, createSelector } from '@ngrx/store';
import { Observable, debounceTime, filter, share } from 'rxjs';

import { betslipSelector } from '../../../../base/store/selectors';
import { IBetslipRootState } from '../../../../base/store/state';
import { BetslipPlaceBetActions } from '../../actions';
import { IPlaceBetErrorState } from '../../place-button.models';

const placeButtonSelector = createSelector(betslipSelector, (state) => ({
    pickState: state.picks,
    types: state.types,
    errors: state.errors,
    placeButton: state.placeButton,
    rewardTokens: state.rewardTokens,
}));

@Injectable()
export class PlaceButtonErrorStateService {
    errorState$: Observable<IPlaceBetErrorState>;

    constructor(
        private store: Store<IBetslipRootState>,
        private userService: UserService,
    ) {
        this.store.dispatch(BetslipPlaceBetActions.setAuthentication({ isAuthenticated: this.userService.isAuthenticated }));

        this.userService.events
            .pipe(
                filter((event) => event instanceof UserLoginEvent || event instanceof UserLogoutEvent),
                filterSportsEmitLast(),
                takeUntilDestroyed(),
            )
            .subscribe(() => this.store.dispatch(BetslipPlaceBetActions.setAuthentication({ isAuthenticated: this.userService.isAuthenticated })));

        this.errorState$ = this.store.select(placeButtonSelector).pipe(
            filter((state) => !!state.types.base.currentSelectedType),
            debounceTime(2),
            share(),
        );
    }

    setInvalid(invalid: boolean): void {
        this.store.dispatch(BetslipPlaceBetActions.validatePlaceButton({ isValid: !invalid }));
    }
}
